"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _utils.createSvgIcon;
  }
});
var _utils = require("@mui/material/utils");


//////////////////
// WEBPACK FOOTER
// ../@mui/icons-material/utils/createSvgIcon.js
// module id = 1863
// module chunks = 22